<template>
  <div class="drawer-wapper-info">
    <div class="operation-tip__wapper">
      <div class="side-frame-error"></div>
      <div class="tip__wapper">
        <div>{{ $l('operation_tip') || '操作提示' }}：</div>

        <div>
          1、{{
            $l('operation_tip_one') ||
              '此功能维护的是坯布面料信息，不是染色后的成品面料，只需填写面料名称、成分、克重、颜色等信息'
          }}
        </div>

        <div>
          2、{{
            $l('operation_tip_two') ||
              '颜色填写说明：坯布颜色，是指坯布的天然颜色，不是具体的成品面料颜色'
          }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No: {{ formData.greyFabricNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.greyFabricStatus === 'Y'
              ? 'success'
              : formData.greyFabricStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_greyFabricStatus || '' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <div class="form-info__wapper d-flex">
      <div class="img-operation__wapper">
        <div class="img__wapper">
          <div @click="onImagePreview">
            <el-image
              class="viewImage"
              fit="scale-down"
              :src="formData.defaultImageUrl"
            >
              <div slot="error" class="image-slot">
                <img src="/image/static/img/nopic.jpg" class="viewImage" />
              </div>
            </el-image>
          </div>
        </div>
        <div class="edit-button" v-if="!disabled">
          <el-button
            size="small"
            :disabled="imageDisabled"
            @click="greyFabricImageVisible = true"
          >
            {{ $l('button_edit_img') || '编辑图片' }}
          </el-button>
        </div>
      </div>
      <div class="greyfabric-info__wapper">
        <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          :disabled="disabled"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_FabricName') || '面料名称'"
                prop="greyFabricName"
              >
                <dict-select
                  v-model="formData.v_greyFabricNameEn"
                  :selectedLabel.sync="formData.greyFabricName"
                  url="/digitalCenter/master/fabric/attributes/attributesSelect"
                  :body="{ fabricAttrTypeEn: 'Fabric Description' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  @change="changeFabricName"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_FabricNameEn') || '面料英文名称'"
                prop="greyFabricNameEn"
              >
                <el-input
                  v-model="formData.greyFabricNameEn"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_greyFabricContent') || '面料成分中文'"
                prop="greyFabricContent"
              >
                <FabricContentInput
                  :fabricContent.sync="formData.greyFabricContent"
                  :fabricContentEn.sync="formData.greyFabricContentEn"
                  :disabled="disabled"
                  size="small"
                />
              </el-form-item>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('form_label_greyFabricContentEn') || '面料成分英文'
                  "
                  prop="greyFabricContentEn"
                >
                  <el-input
                    v-model="formData.greyFabricContentEn"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_color') || '坯布颜色'"
                prop="greyFabricColor"
              >
                <el-input
                  v-model="formData.greyFabricColor"
                  clearable
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_grey_weight') || '坯布克重'"
                prop="greyFabricWeight"
              >
                <el-input-number
                  v-model="formData.greyFabricWeight"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  controls-position="right"
                  :min="0"
                  :max="9999"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_grey_weight_unit') || '克重单位'"
                prop="greyFabricWeightUnit"
              >
                <dict-select
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  size="small"
                  clearable
                  filterable
                  v-model="formData.greyFabricWeightUnit"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'fabricWeightUnit' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_greyFabricAgentCode') || '业务开发'"
                prop="greyFabricAgentCode"
              >
                <dict-select
                  v-model="formData.greyFabricAgentCode"
                  url="/master/common/dict/baseUserSelect"
                  :selectedLabel.sync="formData.greyFabricAgentName"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_greyYarnCount') || '纱线支数'"
                prop="greyYarnCount"
              >
                <el-input-number
                  v-model="formData.greyYarnCount"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  style="width: 100%"
                  controls-position="right"
                  :min="0"
                  :max="9999"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_isCustomerUse') || '是否指定客户使用'"
                prop="isCustomerUse"
              >
                <el-select
                  v-model="formData.isCustomerUse"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in isCustomerUseOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_custCode') || '客户'">
                <dict-select
                  v-model="formData.custCode"
                  url="/master/common/dict/customerSelect"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_scmCode') || '坯布工厂'">
                <dict-select
                  v-model="formData.scmCode"
                  url="/master/common/dict/scmCooperated"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_purchasePrice') || '采购单价'"
              >
                <el-input-number
                  controls-position="right"
                  size="small"
                  style="width: 100%"
                  :min="0"
                  :step="0.01"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  v-model="formData.purchaseUnitPrice"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_purchaseUnit') || '采购计价单位'"
              >
                <dict-select
                  v-model="formData.purchaseUnit"
                  url="/digitalCenter/common/dict/biz"
                  :body="{ dictType: 'fabricYarnUnit' }"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  clearable
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_greyFabricMemo') || '备注说明'"
                prop="greyFabricMemo"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 4 }"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  v-model="formData.greyFabricMemo"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <GreyFabricImage
      v-if="greyFabricImageVisible"
      @closeImage="closeImage"
      :visible="greyFabricImageVisible"
      :greyFabricCode="formData.greyFabricCode"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
    />
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GreyFabricImage from '../greyfabric-img'
import FabricContentInput from '@/views/digital/components/fabric-content-input'
export default {
  mixins: [EditLoading],
  components: { GreyFabricImage, FabricContentInput },
  props: {
    greyFabricCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    imageDisabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        greyFabricCode: '',
        greyFabricNameEn: '',
        v_greyFabricNameEn: '',
        greyFabricName: '',
        greyFabricContent: '',
        greyFabricContentEn: '',
        greyFabricColor: '',
        greyFabricWeight: '',
        greyFabricWeightUnit: 'gsm',
        greyFabricAgentCode: '',
        greyFabricAgentName: '',
        greyFabricAgentDeptCode: '',
        greyFabricAgentDeptName: '',
        greyFabricMemo: '',
        isCustomerUse: '',
        purchaseUnit: '',
        purchaseUnitPrice: '',
        scmCode: '',
        custCode: '',
        listImageUrl: [],
      },
      greyFabricImageVisible: false,

      isCustomerUseOptions: [
        {
          value: 'Y',
          label: this.$l('INDEX.form_label_needInspection_y') || '是',
        },
        {
          value: 'N',
          label: this.$l('INDEX.form_label_needInspection_n') || '否',
        },
      ],
      backDialogVisible: false,
      rules: {
        greyFabricAgentCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        greyFabricName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        greyFabricContent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        greyFabricColor: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        greyFabricWeightUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        greyFabricWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    getGreyFabricCode() {
      return this.greyFabricCode || this.formData.greyFabricCode
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.getGreyFabricCode) return
        if (!userInfo || userInfo === {}) return
        console.log(userInfo)
        const { userCode, userName, userNameEn } = userInfo
        this.formData.greyFabricAgentCode = userCode || ''
        this.formData.greyFabricAgentName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.greyFabricAgentCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        const { depCode, depName } = res.body || {}
        this.formData.greyFabricAgentDeptCode = depCode
        this.formData.greyFabricAgentDeptName = depName
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
    },
    changeFabricName(val) {
      this.formData.greyFabricNameEn = val
    },
    getData() {
      console.log(this.getGreyFabricCode)
      if (!this.getGreyFabricCode) return
      this.$api
        .masterGreyFabricDetailApi({
          greyFabricCode: this.getGreyFabricCode,
        })
        .then((res) => {
          this.formData = res.body
          this.formData.v_greyFabricNameEn = this.formData.greyFabricName
        })
    },
    closeImage() {
      this.greyFabricImageVisible = false
      this.reload()
    },
    async save() {
      const result = await await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      this.$api
        .masterGreyFabricSaveApi({ ...this.formData })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.formData.greyFabricCode) {
            this.close()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-wapper-info {
  padding: 0 30px;
}
.operation-tip__wapper {
  width: 940px;
  height: 100px;
  border-radius: 4px;
  background-color: #fff6f7;
  display: flex;
  margin-bottom: 35px;
  .side-frame-error {
    border-radius: 4px 0px 0px 4px;
    height: 100%;
    width: 7px;
    background-color: #fe6c6f;
  }
  .tip__wapper {
    padding: 5px 7px;
    width: 100%;
    margin-top: 5px;
    color: #101010 !important;
    > div {
      color: #101010 !important;
      font-size: 16px;
    }
    > div:first-child {
      margin-bottom: 5px;
    }
  }
}
.form-info__wapper {
  background-color: #f4f6f9;
  padding: 10px 10px 16px 10px;
  border-radius: 5px;
  .img-operation__wapper {
    .img__wapper {
      width: 80px;
      height: 80px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 7px;
      .viewImage {
        width: 65px;
        height: 65px;
      }
    }
    .edit-button {
      > button {
        border-color: rgba(187, 187, 187, 1) !important;
        border-radius: 5px !important;
      }
    }
  }
  .greyfabric-info__wapper {
    width: 100%;
    margin-left: 10px;
    .edit-fabric-content {
      color: #fff;
      background-color: #a4adb3 !important;
    }
  }
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
